<template>
    <div class="alert-container">
      <v-alert
        class="fade-in-alert"
        style="background-color: #f4e3b2 !important; color: #5a4c00; margin-bottom: 8px; border-radius: 8px; width: 100%; max-width: 750px;"
        v-for="(alert, index) in validationMessages"
        :style="{ animationDelay: `${index * 0.5}s` }"
        :key="'validation-' + index"
        :type="alert.type || 'info'"
        dismissible
        @input="clearAllMessages()"
      >
        {{ alert.msg }}
      </v-alert>
    </div>
  </template>
  
  <script>
  export default {
    name: "BaseValidationAlerts",
    props: {
      context: {
        type: String,
        required: true, // Enforces that the parent component passes the context
      },
    },
    computed: {
      validationMessages() {
        // Dynamically fetch validation messages using the context
        return this.$store.getters[`getValidationMessages${this.context}`] || [];
      },
    },
    methods: {
      clearAllMessages() {
        // Clear all messages for the given context
        this.$store.commit(`setValidationMessages${this.context}`, []);
      },
    },
  };
  </script>
  
  <style scoped>
  .alert-container {
    position: fixed;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
    width: 70%;
    max-width: 650px;
  }
  
  .fade-in-alert {
    animation: fadeIn 0.5s ease-in-out forwards;
    opacity: 0;
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  </style>
  